import { IScenarioDetail } from '../../interfaces/iscenario-detail';
import { AssetTeam } from '../asset-team';
import { Scenario } from '../scenario';

export class ScenarioDetailBase {
  ScenarioDetailId: number;
  ScenarioId: number;
  Description: string;
  PublishId: number;
  CreateTStamp: Date;
  SortOrder: number | null;
  StimEfficiency: number | null;
  AssetTeamId: number;
  UniqueId: number;
  RigRampWellSet: boolean;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;

  AssetTeam?: AssetTeam;
  Scenario?: Scenario;

  constructor(item?: IScenarioDetail) {
    if (item) {

      this.ScenarioDetailId = item.ScenarioDetailId;
      this.ScenarioId = item.ScenarioId;
      this.Description = item.Description;
      this.PublishId = item.PublishId;
      this.CreateTStamp = item.CreateTStamp ? new Date(item.CreateTStamp) : null;
      this.SortOrder = item.SortOrder;
      this.StimEfficiency = item.StimEfficiency;
      this.AssetTeamId = item.AssetTeamId;
      this.UniqueId = item.UniqueId;
      this.RigRampWellSet = item.RigRampWellSet;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;

      this.AssetTeam = new AssetTeam(item.AssetTeam);
      this.Scenario = new Scenario(item.Scenario);
    }
  }
}